"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var lodash_1 = require("lodash");
var AutoGrowTextInput = (0, mobx_react_1.observer)(function (_a) {
    var value = _a.value, className = _a.className, placeholder = _a.placeholder, props = __rest(_a, ["value", "className", "placeholder"]);
    var rulerRef = (0, react_1.useRef)(null);
    var inputRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(0), 2), rulerRefWidth = _b[0], setRulerRefWidth = _b[1];
    (0, utils_1.useLayoutEffect)(function () {
        var observer = undefined;
        if (!(0, lodash_1.isNil)(rulerRef.current)) {
            observer = (0, observe_rect_1.default)(rulerRef.current, function () {
                var _a, _b;
                var newValue = (_b = (_a = rulerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0;
                setRulerRefWidth(newValue);
            });
            observer.observe();
        }
        return function () {
            observer === null || observer === void 0 ? void 0 : observer.unobserve();
        };
    }, [rulerRef]);
    (0, utils_1.useLayoutEffect)(function () {
        if (inputRef.current) {
            inputRef.current.style.width = "".concat(rulerRefWidth, "px");
        }
    }, [inputRef, rulerRefWidth]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("auto-grow-text-input", className) },
        react_1.default.createElement("span", { className: "auto-grow-text-input__ruler text-input__input", "aria-hidden": "true", ref: rulerRef }, value || placeholder || "_"),
        react_1.default.createElement(kaleidoscope_1.TextInput, __assign({ className: "auto-grow-text-input__input", ref: inputRef, value: value }, props))));
});
exports.default = AutoGrowTextInput;
